export default {
    setEstimates(state, estimates) {
        state.estimates = estimates;
    },
    setDrafts(state, estimates) {
        state.drafts = estimates;
    },
    setActiveEstimate(state, estimate) {
        state.activeEstimate = estimate;
    },
    setManageEstimateDialog(state, status) {
        state.manageEstimateDialog = status;
    },
    setDeleteEstimateDialog(state, status) {
        state.deleteEstimateDialog = status;
    },
    resetActiveEstimate(state) {
        state.activeEstimate = getNewEstimate();
    }
}

function getNewEstimate() {
    return {
        startDate: new Date().toISOString().substr(0, 10),
        startTime: '08:30',
        total: 0.00,
        discountValue: null
    }
}
